export interface InstagramIconProps {
    className: string;
}

export function InstagramIcon({className = ''}: InstagramIconProps) {
    return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.92 22.96" className={`w-full ${className}`}>
        <path d="M17.39,0H5.53C2.48,0,0,2.48,0,5.54v11.87c0,3.06,2.48,5.54,5.53,5.54h11.86c3.06,0,5.53-2.48,5.53-5.54V5.54c0-3.06-2.48-5.54-5.53-5.54ZM20.95,17.02c0,2.18-1.77,3.96-3.95,3.96H5.93c-2.18,0-3.95-1.77-3.95-3.96V5.94c0-2.19,1.77-3.96,3.95-3.96h11.07c2.18,0,3.95,1.77,3.95,3.96v11.08Z"/>
        <path d="M11.46,5.54c-3.27,0-5.93,2.66-5.93,5.94s2.66,5.94,5.93,5.94,5.93-2.66,5.93-5.94-2.66-5.94-5.93-5.94ZM11.46,15.44c-2.18,0-3.95-1.78-3.95-3.96s1.78-3.96,3.95-3.96,3.95,1.78,3.95,3.96-1.78,3.96-3.95,3.96Z"/>
        <path d="M17.79,6.33c-.65,0-1.19-.53-1.19-1.19s.53-1.19,1.19-1.19,1.19.53,1.19,1.19-.53,1.19-1.19,1.19Z"/>
    </svg>
    )
}